import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import {
  InvalidationReason,
  InvalidationReasonCategory,
} from '@app/core/types/identity-verification';

@Component({
  selector: 'itfg-identity-category-submenu',
  template: `
    <mat-menu #menu="matMenu">
      @for (reason of category.reasons; track reason) {
        <button
          mat-menu-item
          [disabled]="disabled"
          (click)="reasonSelected.emit(reason)"
        >
          <span>{{
            'verification.id.documentActions.changeState.' + reason | translate
          }}</span>
        </button>
      }
    </mat-menu>
  `,
  standalone: false,
})
export class IdentityCategorySubmenuComponent {
  @Input({ required: true }) category!: InvalidationReasonCategory;
  @Input() disabled = false;
  @Output() reasonSelected = new EventEmitter<InvalidationReason>();

  @ViewChild('menu', { static: true }) menu!: MatMenu;
}